<template>
  <v-card class="mb-4" variant="flat">
    <v-card-text>
      <div class="d-flex align-center justify-space-between flex-wrap ga-4">
        <div class="d-flex align-center ga-4">
          <v-avatar
            class="bg-indigo-lighten-5 text-primary font-weight-bold"
            size="72">
            <span class="font-size-22">{{ initials }}</span>
          </v-avatar>

          <div class="d-flex flex-column ga-2">
            <div>
              <div class="font-size-18 font-weight-bold">
                {{ contractor.shortName || contractor.name }}
              </div>
              <div class="font-size-13 text-medium-emphasis">
                {{ contractor.name }}
              </div>
            </div>

            <div class="d-flex align-center flex-wrap ga-2">
              <v-chip
                class="font-weight-bold text-uppercase"
                color="deep-purple"
                size="small"
                variant="tonal">
                {{ typeName }}
              </v-chip>
              <v-chip
                class="font-weight-bold text-uppercase"
                color="success"
                size="small"
                variant="tonal">
                {{ statusLabel }}
              </v-chip>
              <div class="d-flex align-center ga-2 font-size-12">
                <span class="text-medium-emphasis">ЄДРПОУ/ІПН:</span>
                <span class="font-weight-bold">{{ contractor.code }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { useContractorStore } from '@/pages/contractor/single/contractor'

export default {
  name: 'ContractorHeader',
  setup() {
    return useContractorStore()
  },
}
</script>
